// Which row actions conflict with bulk work. While a selection is active a row mutation is blocked in place
// and explains how to restore it; a destination (an href with no command), and an action the consumer marks
// batchSafe, stays operable.

import { BATCH_DISABLED } from './copy'
import { isActive } from './selection'

const NOT_BLOCKED = Object.freeze({ blocked: false, reason: null })
const BLOCKED = Object.freeze({ blocked: true, reason: BATCH_DISABLED })

const isText = value => typeof value === 'string' && value.trim() !== ''

/** Whether one row action conflicts with bulk work. */
export const conflicts = action =>
  Boolean(action) &&
  action.batchSafe !== true &&
  !(isText(action.href) && typeof action.onSelect !== 'function')

/**
 * The table's rowActionState(action) for the current selection: {blocked, reason}.
 * @param {?import('../types').SelectionState} selection
 * @param {boolean} [pending] bulk work is running
 */
export const rowActionStateFor = (selection, pending = false) => {
  const selecting = pending || isActive(selection)
  return action => (selecting && conflicts(action) ? BLOCKED : NOT_BLOCKED)
}
